import React from 'react'
import {useIntl} from 'react-intl'
import {useLocation} from 'react-router-dom'
import {StripeBanner} from '../../../partials/widgets'
import {toAbsoluteUrl} from '../../../helpers'
import {ROUTES} from '../../../constants'
import {UseSessionBanner, isWithin} from '../../../hooks/UseSessionBanner'

const SESSION_KEY = 'banner_dismissed_usps_2026'
// PRD 模块B — effective immediately through end of August (US Pacific).
const EFFECTIVE_UNTIL = '2026-08-31T23:59:59-07:00'
const BLOG_URL =
  'https://shipbae.com/resources/blog/usps-july-2026-shipping-changes-hazmat-dim-weight'

const UspsStripeBanner: React.FC = () => {
  const intl = useIntl()
  const {pathname} = useLocation()
  const {dismissed, dismiss} = UseSessionBanner(SESSION_KEY)

  if (dismissed || !isWithin(undefined, EFFECTIVE_UNTIL)) return null

  const learnMore = intl.formatMessage({id: 'LEARN_MORE'})
  const isBatches = pathname.startsWith(ROUTES.BATCHES.BASE)

  if (isBatches) {
    return (
      <StripeBanner
        variant='usps-hazmat'
        background='#FFFAE8'
        textColor='#0F1A2A'
        closeWhite={false}
        href={BLOG_URL}
        external
        onClose={dismiss}
        cta={{label: learnMore, background: '#FFB700', color: '#0F1A2A'}}
        icon={
          <img
            src={toAbsoluteUrl('/media/gori/promotions/usps/battery.svg')}
            alt=''
            width={24}
            height={24}
          />
        }
      >
        <p className='stripe-banner__title'>
          <span className='stripe-banner__title-full'>
            {intl.formatMessage({id: 'BANNER_USPS_HAZMAT_TITLE'})}
          </span>
          <span className='stripe-banner__title-compact'>
            {intl.formatMessage({id: 'BANNER_USPS_HAZMAT_TITLE_COMPACT'})}
          </span>
        </p>
        <p className='stripe-banner__subtext'>
          {intl.formatMessage({id: 'BANNER_USPS_HAZMAT_SUBTEXT'})}
        </p>
      </StripeBanner>
    )
  }

  return (
    <StripeBanner
      variant='usps'
      background='#0056A1'
      href={BLOG_URL}
      external
      onClose={dismiss}
      cta={{label: learnMore, background: '#F1BC00', color: '#0F1A2A'}}
      icon={
        <>
          <span className='stripe-banner__usps-logo'>
            <img
              src={toAbsoluteUrl('/media/gori/promotions/usps/usps-logo.svg')}
              alt='USPS'
              width={87}
              height={17}
            />
          </span>
          <img
            src={toAbsoluteUrl('/media/gori/promotions/usps/usps-warning.svg')}
            alt=''
            width={22}
            height={19}
          />
        </>
      }
    >
      <p className='stripe-banner__title'>{intl.formatMessage({id: 'BANNER_USPS_TITLE'})}</p>
      <p className='stripe-banner__subtext'>{intl.formatMessage({id: 'BANNER_USPS_SUBTEXT'})}</p>
    </StripeBanner>
  )
}

export {UspsStripeBanner}
